import { ClientProvider } from "@ceeferenderer/fe-renderer-sdk/rest/ClientProvider";
import type { FeHttpClientRequest } from "@ceeferenderer/fe-renderer-sdk";

type Fetch = WindowOrWorkerGlobalScope["fetch"];
export class FetchClientProvider extends ClientProvider {
  private fetch: Fetch;

  constructor(fetch: Fetch = window.fetch) {
    super();
    this.fetch = fetch;
    this.generic = this.generic.bind(this);
    this.get = this.generic.bind(this);
    this.post = this.generic.bind(this);
  }

  async generic<T>({ headers, query, url, methodType, payload }: FeHttpClientRequest<HeadersInit>): Promise<T> {
    const urlWithParams = new URL(url);
    urlWithParams.search = new URLSearchParams(query).toString();
    const options: RequestInit = {
      headers,
      method: methodType || "POST",
    };
    if (payload) {
      options.body = JSON.stringify(payload);
    }
    return (await (await this.fetch(urlWithParams.toString(), options)).json()) as unknown as T;
  }

  async get<T>(request: FeHttpClientRequest<HeadersInit>): Promise<T> {
    return this.generic<T>({ ...request, methodType: "GET" });
  }

  async post<T>(request: FeHttpClientRequest<HeadersInit>): Promise<T> {
    return this.generic<T>({ ...request, methodType: "POST" });
  }
}
